import * as ts from './serviceTransport';
/*
export class LocalizationService extends NewType {}
export class LocalizationsService extends ts.LocalizationsServiceTransport {}
*/
export class  BillingService extends ts.BillingServiceTransport {}
export class  AuthenticationService extends ts.AuthenticationServiceTransport {}
export class  UserService extends ts.UserServiceTransport {}
export class  Home extends ts.HomeServiceTransport {}
export class  ProjectService extends ts.ProjectsServiceTransport {}